import React from "react";

const useLevelName = (inputValue?: string | number) => {
  if (typeof inputValue === "undefined") return "";
  const value = Number(inputValue);
  if (isNaN(value)) return "";
  switch (value) {
    case 0:
      return "Corporate";
    case 1:
      return "Division";
    case 2:
      return "Department";
    default:
      return "Department";
  }
};

export default useLevelName;
